<template>
  <div class="error-page">
    <div class="error-content-block">
      <div class="error-content">
        <i class="iconfont icon-caution"></i> <span>温馨提示<br>请先导入数据</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {}
</script>

<style scoped lang="less">
  @import '../style/base.less';
  .error-page {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .error-content-block {
    width: 27em;
    height: 12.2em;
    border: 0.1em solid #651b97;
    background-color: #f590f5;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.2em;
  }
  .error-content {
    color: #651b97;
    display: flex;
    i {
      font-size: 3em;
    }
    span {
      letter-spacing: 0.1em;
      padding-left: 1em;
      font-size: 1.3em;
    }
  }
</style>



// WEBPACK FOOTER //
// error.vue?c8bacdd6